import * as React from 'react';

// REDUX
import { useAppSelector } from '../../../store';

// PACKAGES
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import Button from '../../../components/Button';
import GlobalModal from '../../../components/GlobalModal';
import DisplayDateTime from '../../../components/DisplayDateTime';
import FeedbackProgressModal, { ViewTypes } from './FeedbackProgressModal';
import LoadingSpinner from '../../../components/LoadingSpinner';

// ICONS
import { ReactComponent as PlusIcon } from '../../../assets/svg/plus.svg';

// TYPES
import { FeedbackActionsAction } from '../../../api/models';

interface FeedbackProgressType {
	feedbackId?: string;
	canUpdate?: boolean;
	feedbackProgressData: FeedbackActionsAction[];
	getFeedbackProgress: (id: string | undefined) => Promise<void>;
	feedbackProgressFormErrorMessage?: string;
	isLoading: boolean;
}

export const FeedbackProgress: React.FC<FeedbackProgressType> = ({
	feedbackId,
	canUpdate,
	feedbackProgressData,
	getFeedbackProgress,
	feedbackProgressFormErrorMessage,
	isLoading
}) => {
	// Check if Organisation is active
	const isOrganisationActive = useAppSelector((state) => state.user.isOrganisationActive);

	// Set up Modal States
	const [showCreateModal, setShowCreateModal] = React.useState<boolean>(false);

	const [showReadModal, setShowReadModal] = React.useState<boolean>(false);

	const [modalData, setModalData] = React.useState<FeedbackActionsAction>();

	const createItem = () => {
		setShowReadModal(false);

		setShowCreateModal(true);
	};

	const readItem = (index: number) => {
		const item = feedbackProgressData[index];

		setModalData(item);

		setShowCreateModal(false);

		setShowReadModal(true);
	};

	return (
		<aside className="feed-list">
			{!!feedbackProgressFormErrorMessage ? (
				<div className="form-validation-error">{feedbackProgressFormErrorMessage}</div>
			) : (
				<SwitchTransition>
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<header>
									<h1 className="h4">Feedback progress</h1>
									
									{isOrganisationActive && canUpdate && (
										<Button className="btn-secondary small" buttonIcon={<PlusIcon />} onClick={createItem}>
											Log action
										</Button>
									)}
								</header>

								<ul>
									{feedbackProgressData &&
										feedbackProgressData.length > 0 &&
										feedbackProgressData.map((item, index) => (
											<li key={index}>
												<div>
													<p>{item.title}</p>

													<time>
														<DisplayDateTime>{item.occurrence}</DisplayDateTime>
													</time>
												</div>

												<Button className="btn-icon" buttonIcon={<PlusIcon />} onClick={() => readItem(index)}></Button>
											</li>
										))}
								</ul>

								<GlobalModal isOpen={showCreateModal} setIsOpen={setShowCreateModal} titleText="Log an activity">
									<FeedbackProgressModal
										viewType={ViewTypes.Create}
										refreshFeedbackProgress={getFeedbackProgress}
										feedbackId={feedbackId}
									/>
								</GlobalModal>

								<GlobalModal isOpen={showReadModal} setIsOpen={setShowReadModal} titleText="Activity Feed">
									<FeedbackProgressModal
										viewType={ViewTypes.Read}
										activity={modalData}
										refreshFeedbackProgress={getFeedbackProgress}
										feedbackId={feedbackId}
									/>
								</GlobalModal>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</aside>
	);
};

export default FeedbackProgress;
